import commBg from '../assets/comm_bg_new.jpg'
import SectionHeading from '../components/SectionHeading'
import Reveal from '../components/Reveal'
import { useLanguage } from '../i18n/LanguageContext'
import { commContent } from '../i18n/content/comm'

export default function Comm(){
    const { lang } = useLanguage();
    const c = commContent[lang];
    const steps = c.steps.map((step, i) => ({ n: i + 1, ...step }));
    return (
        <section className="relative overflow-hidden" id="comm" style={{backgroundColor: 'var(--bg-color)'}}>
            {/* Faint background collage */}
            <div
                className="absolute inset-0 z-0 pointer-events-none"
                style={{
                    backgroundImage: `url(${commBg})`,
                    backgroundAttachment: 'fixed',
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',
                    opacity: '0.06'
                }}
            ></div>

            <div className="comm relative z-10">
                <div className="main-content pt-16 pb-2">
                    <Reveal className="mb-14">
                        <SectionHeading eyebrow={c.eyebrow} title={c.title} />
                    </Reveal>

                    {/* Steps */}
                    <div className="relative max-w-5xl mx-auto">
                        {/* Connecting line (desktop only) */}
                        <div className="hidden md:block absolute left-0 right-0 top-6 h-px bg-line" style={{ marginInline: 'calc(100%/6)' }}></div>

                        <div className="grid md:grid-cols-3 gap-12 md:gap-8">
                            {steps.map((step, i) => (
                                <Reveal key={step.n} delay={i * 120} className="relative">
                                    <p
                                        className="font-black text-primary leading-none select-none"
                                        style={{ fontSize: 'clamp(3rem, 2rem + 4vw, 5rem)' }}
                                    >
                                        0{step.n}
                                    </p>
                                    <h3 className="text-xl font-bold text-ink mt-2 mb-2">{step.title}</h3>
                                    <p className="text-ink-muted leading-relaxed">{step.body}</p>
                                </Reveal>
                            ))}
                        </div>
                    </div>

                    {/* Final CTA panel */}
                    <Reveal className="max-w-5xl mx-auto mt-12 pb-16">
                        <div className="rounded-card-lg p-8 sm:p-10 md:p-16 shadow-lg border border-line" style={{background: 'linear-gradient(135deg, #0b1640 0%, #0a1a5f 45%, #1533a6 100%)'}}>
                            <div className="text-center">
                                <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-white mb-10 leading-tight">
                                    {c.ctaTitle}
                                </h2>
                                <a
                                    href="#services"
                                    className="inline-flex items-center justify-center px-10 py-4 gold-gradient text-white rounded-full font-bold text-lg transition-all duration-300 hover:scale-105 shadow-lg"
                                >
                                    {c.ctaButton}
                                </a>
                            </div>
                        </div>
                    </Reveal>
                </div>
            </div>
        </section>
    )
}
